class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[options][fields]=title,body,product_type,variants.title,tag`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';

    // show custom "no results" message
    const template = document.getElementById('no-search-results-template');
    const wrapper = document.getElementById('no-search-results-content-wrapper');

    if (template && wrapper) {
      const content = template.content.cloneNode(true);

      wrapper.innerHTML = '';
      wrapper.appendChild(content);
    }

    // show empty state menu
    if (document.querySelector('.js-default-search-results'))
      document.querySelector('.js-default-search-results').hidden = true;
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';

    // hide empty state menu
    if (document.querySelector('.js-default-search-results'))
      document.querySelector('.js-default-search-results').hidden = false;
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
